// extracted by mini-css-extract-plugin
export default {"row":"styles_row__kM-oo","maintitle":"styles_maintitle__afYGy","searchCol":"styles_searchCol__7TWyP"};